<template>
  <div>
    <h1 class="title">Crear empresas</h1>
    <div class="notification">
      <strong>Crear empresa</strong> Con el siguiente botón podra crear las
      empresas en yungol. <br />
      <br /><br />
      <button
        class="button"
        :class="showform ? '' : 'is-link'"
        @click="showformEmpresa"
      >
        Lista de Empresas
      </button>
      <button
        class="button"
        :class="showform ? 'is-link' : ''"
        @click="showformEmpresa"
      >
        Crear empresa
      </button>
    </div>
    <table class="table" v-show="!showform">
      <thead>
        <tr>
          <th></th>
          <th>Nombre</th>
          <th>Nit</th>
          <th>Direccion</th>
          <th>Telefono</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in empresas" :key="index">
          <td>{{ index + 1 }}</td>
          <td>{{ item.nombre }}</td>
          <td>{{ item.nit }}</td>
          <td>{{ item.direccion }}</td>
          <td>{{ item.telefono }}</td>
        </tr>
      </tbody>
    </table>
    <div class="box" v-show="showform">
      <h1 class="title is-4">Agregar Empresa</h1>
      <div class="columns is-multiline">
        <div class="column is-6">
          <div class="field">
            <label class="label">Nombre</label>
            <div class="control">
              <input
                v-model="empresatosave.nombre"
                class="input"
                type="text"
                placeholder="Nombre"
              />
            </div>
          </div>
        </div>
        <div class="column is-6">
          <div class="field">
            <label class="label">Abreviatura del nombre</label>
            <div class="control">
              <input
                v-model="empresatosave.nombrec"
                class="input"
                type="text"
                placeholder="Nombre"
              />
            </div>
          </div>
        </div>
        <div class="column is-6">
          <div class="field">
            <label class="label">RUT</label>
            <div class="control">
              <input
                v-model="empresatosave.nit"
                class="input"
                type="text"
                placeholder="Registro unico tributario"
              />
            </div>
          </div>
        </div>
        <div class="column is-6">
          <div class="field">
            <label class="label">Direccion</label>
            <div class="control">
              <input
                v-model="empresatosave.direccion"
                class="input"
                type="text"
                placeholder="Direccion"
              />
            </div>
          </div>
        </div>
        <div class="column is-6">
          <div class="field">
            <label class="label">Telefono</label>
            <div class="control">
              <input
                v-model="empresatosave.telefono"
                class="input"
                type="text"
                placeholder="Telefono"
              />
            </div>
          </div>
        </div>
        <div class="column is-6">
          <div class="field">
            <label class="label">Correo</label>
            <div class="control">
              <input
                v-model="empresatosave.correo"
                class="input"
                type="text"
                placeholder="Correo"
              />
            </div>
          </div>
        </div>
        <div class="column">
          <button class="button is-link" @click="saveEmpresa">Guardar</button>
          <button class="button" @click="showformEmpresa">Cancelar</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import apiServices from "@/services/yungol-services";
export default {
  data() {
    return {
      showform: false,
      empresatosave: {
        nombre: null,
        nombrec: null,
        nit: null,
        direccion: null,
        telefono: null,
        correo: null,
        codciudad: "05-001",
        ciudad: "Medellín - Antioquia",
      },
      empresas: [],
    };
  },
  methods: {
    async saveEmpresa() {
      try {
        if (!this.empresatosave.nombre) {
          this.$store.dispatch("notify", {
            message: "Debe ingresar un nombre de empresa.",
            type: "is-warning",
            position: "top-center",
          });
          return false;
        }
        if (!this.empresatosave.nombrec) {
          this.$store.dispatch("notify", {
            message: "Debe ingresar una abreviatura para la empresa.",
            type: "is-warning",
            position: "top-center",
          });
          return false;
        }
        if (!this.empresatosave.nit) {
          this.$store.dispatch("notify", {
            message: "Debe ingresar el nit de la empresa.",
            type: "is-warning",
            position: "top-center",
          });
          return false;
        }
        if (!this.empresatosave.direccion) {
          this.$store.dispatch("notify", {
            message: "Debe ingresar la direccion de la empresa.",
            type: "is-warning",
            position: "top-center",
          });
          return false;
        }
        if (!this.empresatosave.telefono) {
          this.$store.dispatch("notify", {
            message: "Debe ingresar el telefono de la empresa.",
            type: "is-warning",
            position: "top-center",
          });
          return false;
        }
        const result = await apiServices.post(
          `/saveempresas`,
          this.empresatosave
        );
        if (result.data) {
          console.log(result.data);
          this.$store.dispatch("notify", {
            message: result.data.message,
            position: "top-center",
          });
          this.showform = false;
          this.findEmpresas();
        }
      } catch (err) {
        console.log(err);
      }
    },
    showformEmpresa() {
      if (this.showform) {
        this.showform = false;
      } else {
        this.empresatosave.nombre = null;
        this.empresatosave.nombrec = null;
        this.empresatosave.nit = null;
        this.empresatosave.direccion = null;
        this.empresatosave.telefono = null;
        this.empresatosave.correo = null;
        this.showform = true;
      }
    },
    async findEmpresas() {
      let result;
      try {
        result = await apiServices.get(`/empresas`);
        this.empresas = result.data;
      } catch (error) {
        console.log(error);
      }
    },
  },
  created() {
    this.findEmpresas();
  },
};
</script>


// WEBPACK FOOTER //
// src/components/admin/empresa/NewEmpresa.vue